import React from "react";
import "./initialScreen.css";

export const InitialScreenComponent: React.FC<{
    showMayaRoom: () => void;
    style: React.CSSProperties;
}> = ({ showMayaRoom, style }) => {
    const checkIsMobile = () => {
        if (matchMedia("(pointer:fine)").matches) {
            return false;
        }
        return true;
    };

    return (
        <div id="site" style={style}>
            <div id="siteContent" className="siteContent">
                <div id="MainLink" style={{ display: "block" }}>
                    <div className="main">
                        <button
                            className="enter-site-btn"
                            onClick={showMayaRoom}
                            aria-label="הסוד של מיה, כניסה לאתר"
                        ></button>
                    </div>
                </div>
            </div>
            {checkIsMobile() && <div className="message-center">*לצפיה באתר המלא אנא גלוש/י ממחשב שולחני</div>}
            <div className="footer">
                <div className="footer-center">במידה ונתקלת בבעיה, אנא פנה לתמיכה בטלפון 09-8922913</div>
            </div>
        </div>
    );
};
